module.exports = __webpack_public_path__ + "img/glass.ea453bee.svg";